import { useMemo } from 'react';

/** Returns a memoized version of the given object unless the values of the object change. */
export function useMemoObject<T extends object>(obj: T): T {
  // oxlint-disable-next-line react/exhaustive-deps
  return useMemo(() => obj, Object.values(obj));
}
